import React from 'react';

const WavyBackground = ({ children, className = "" }) => {
  return (
    <div className={`wavy-background ${className}`}>
      <div className="electric-lines-container">
        <div className="electric-line electric-line-aurora"></div>
        <div className="electric-line electric-line-lumen"></div>
        <div className="electric-line electric-line-green"></div>
        <div className="electric-line electric-line-cyan"></div>
        <div className="electric-line electric-line-blue"></div>
        <div className="electric-line electric-line-purple"></div>
        <div className="electric-line electric-line-magenta"></div>
        <div className="electric-line electric-line-amber"></div>
        <div className="electric-line electric-line-rose"></div>
        <div className="electric-line electric-line-emerald"></div>
        <div className="electric-line electric-line-indigo"></div>
        <div className="electric-line electric-line-halo"></div>
        <div className="electric-line electric-line-nebula"></div>
      </div>

      <div className="wavy-content">
        {children}
      </div>
    </div>
  );
};

export default WavyBackground;
